"use strict";
/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Dashboard
 *| (C) Copyright IBM Corp. 2020
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */

var __extends = void 0 && (void 0).__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importStar = void 0 && (void 0).__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importStar(require("react"));

var mobx_react_1 = require("mobx-react");

var ca_ui_toolkit_1 = require("ca-ui-toolkit");

var StringResources_1 = __importDefault(require("../../nls/StringResources"));

var FieldDropdown_1 = __importDefault(require("./FieldDropdown"));

require("./colorByComponent.scss");

var ColorByComponent =
/** @class */
function (_super) {
  __extends(ColorByComponent, _super);

  function ColorByComponent(props) {
    var _this = _super.call(this, props) || this;

    _this._fieldDropdowRef = react_1.default.createRef();
    return _this;
  }

  ColorByComponent.prototype.render = function () {
    return react_1.default.createElement(ca_ui_toolkit_1.FlexLayout, {
      className: 'vis-cf-colorByFlexWrapper'
    }, react_1.default.createElement(ca_ui_toolkit_1.FlexItem, {
      className: 'vis-cf-colorBySection'
    }, react_1.default.createElement(ca_ui_toolkit_1.Label, {
      label: StringResources_1.default.get('colorBy')
    })), react_1.default.createElement(ca_ui_toolkit_1.FlexItem, {
      className: "vis-cf-item-wrapper"
    }, this._renderItemField()));
  };

  ColorByComponent.prototype.onSlideoutMounted = function () {
    if (this._fieldDropdowRef.current) {
      this._fieldDropdowRef.current.onSlideoutMounted();
    }
  };

  ColorByComponent.prototype._renderItemField = function () {
    return react_1.default.createElement(FieldDropdown_1.default, __assign({
      ref: this._fieldDropdowRef
    }, this.props));
  };

  return ColorByComponent;
}(react_1.Component);

exports.default = mobx_react_1.observer(ColorByComponent);
